import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';


import { ResolvedConceptCard } from './ResolvedConceptCard';
import { useResolvedTab } from './useResolvedTab';
import { ResolvedConceptAnnotations } from '../../../../../../features/supervisor/types/types';

export const ResolvedTab = () => {
  const {
    resolvedConceptCards,
    resolvedDataLoading,
    setAllConceptsExpanded,
    clearAllConceptsExpanded,
  } = useResolvedTab();
  const theme = useTheme();
  const { formatMessage } = useIntl();

  if (resolvedDataLoading) {
    return <Skeleton variant="rectangular" height={100} />;
  }
  if (resolvedConceptCards.length <= 0) {
    return (
      <Box>
        <Typography variant="h6">
          {formatMessage({ id: 'supervisorReview.finalizedTab.noAnnotations' })}
        </Typography>
      </Box>
    );
  }
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(4), cursor: 'pointer' }}>
        <Typography
          onClick={setAllConceptsExpanded}
          variant="body1"
          sx={{ color: theme.palette.primary.main, fontWeight: '400' }}
        >
          {formatMessage({ id: 'workspaceCommon.annotations.expandAllButton' })}
        </Typography>
        <Typography
          onClick={clearAllConceptsExpanded}
          variant="body1"
          sx={{ color: theme.palette.primary.main, fontWeight: '400' }}
        >
          {formatMessage({ id: 'workspaceCommon.annotations.collapseAllButton' })}
        </Typography>
      </Box>
      {resolvedConceptCards &&
        resolvedConceptCards.map((resolvedConceptCard) => (
          <Box key={resolvedConceptCard.conceptId}>
            <ResolvedConceptCard
              resolvedInConcept={resolvedConceptCard as ResolvedConceptAnnotations}
            />
          </Box>
        ))}
    </Box>
  );
};
